import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.833 4.616a.5.5 0 1 0-.706.708L14.812 12l-6.685 6.676a.5.5 0 1 0 .706.708l7.04-7.03a.5.5 0 0 0 0-.708z"
    />
  </svg>
);
export default SvgChevronRight;
